const DATA_ATTR    = 'data-document-card';
const CLASS_PREFIX = 'document-card';


export function document(container) {

}
